import React from 'react';
import PropTypes from 'prop-types';
import { Field } from '../../../libs/reduxForm';
import { RadioButton } from '../../../components';

var RadioField = function RadioField(_ref) {
  var name = _ref.name,
      label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange;
  return React.createElement(Field, {
    onChange: onChange,
    name: name,
    label: label,
    component: RadioButton,
    type: 'radio',
    value: value
  });
};

RadioField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};
export default RadioField;